import SocialAccountSettings from "@/js/Components/SocialAccountSettings";
import { useConnectorLink } from "@/js/Layouts/Connector";
import React, { useMemo } from "react";
import { Navigate, useNavigate, useParams } from "react-router";

export default function Settings() {
    const {type} = useParams();
    const {connectorLink: {sid, accounts}, refresh} = useConnectorLink();
    const id = useMemo(() => accounts.find(account => account.type === type)?.id ?? null, [accounts, type]);
    const navigate = useNavigate();

    const handleClose = async (shouldRefresh: boolean) => {
        if (shouldRefresh) await refresh();
        navigate("..");
    }

    if (id === null) {
        return <Navigate to=".." replace />
    }

    return (
        <div className="flex flex-col rounded-xl shadow-card bg-bg-100 max-w-[500px] w-full">
            <SocialAccountSettings sid={sid} socialAccountId={id} onClose={handleClose} />
        </div>
    )
}